import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, AfterViewInit
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-waiver-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'waiver-dialog.template.html',
  animations: [
    trigger('slideIn', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('* => void', [
        style({ height: '*' }),
        animate(250, style({ height: 0 }))
      ]),
      transition('void => *', [
        style({ height: '0' }),
        animate(250, style({ height: '*' }))
      ])
    ])
  ]
})

export class WaiverDialogComponent implements OnInit {
  public form: FormGroup;
  public formErrors = {
    title: '',
    content: ''
  };
  public waiver: any;
  loading = false;

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<WaiverDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    if ( data ) {
      this.waiver = Object.assign({}, data);
    } else {
      this.waiver = {};
    }
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public buildForm() {
    this.form = this.formBuilder.group({

      label: new FormControl( this.waiver ? this.waiver.label : '', [
        Validators.required,
        Validators.minLength(3)
      ]),
      title: new FormControl( this.waiver ? this.waiver.title : '', [
        Validators.required,
        Validators.minLength(3)
      ]),
      content: new FormControl( this.waiver ? this.waiver.content : '', [
        Validators.required
      ]),

      required: new FormControl( this.waiver ? this.waiver.required : true, [
      ]),
    });
  }

  public save() {
    //this.waiver['title'] = this.form.value.title;
    //this.waiver['content'] = this.form.value.content;

    this.dialogRef.close(Object.assign(this.waiver, this.form.value));
  }

  public cancel() {
    this.dialogRef.close();
  }

}
